import { AtlasBodyMain, CardComponent } from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { FlexRowAtom } from 'components/atoms/FlexRow.atom'

interface CardInfoProps {
  icon: string
  description: string
  subtitle?: string
  subtitleIcon?: string
}

export const CardInfoMolecule = (props: CardInfoProps) => {
  return (
    <CardComponent $variant="highlight">
      <FlexRowAtom $gap={8}>
        <Icon name={props.icon} size={15} />
        <AtlasBodyMain>{props.description}</AtlasBodyMain>
      </FlexRowAtom>

      {props.subtitle && props.subtitleIcon && (
        <FlexRowAtom $gap={8}>
          <Icon name={props.subtitleIcon} size={15} color="white" />
          <AtlasBodyMain>{props.subtitle}</AtlasBodyMain>
        </FlexRowAtom>
      )}
    </CardComponent>
  )
}
